"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.function.name.js");
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _customer = require("@/api/customer.api");
var _SingleImage = _interopRequireDefault(require("@/components/Upload/SingleImage.vue"));
var _building = require("@/api/building.api");
var rule = {
  trigger: "submit",
  required: true,
  message: "Bắt buộc"
};
var CustomerModal = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(CustomerModal, _Vue);
  var _super = (0, _createSuper2.default)(CustomerModal);
  function CustomerModal() {
    var _this;
    (0, _classCallCheck2.default)(this, CustomerModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "visible", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "form", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "status", "create");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rules", {
      name: rule,
      address: rule,
      email: rule,
      phone: rule,
      identification: rule,
      identificationDate: rule,
      buildingId: rule
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadingBlock", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "tab", "");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildings", []);
    return _this;
  }
  (0, _createClass2.default)(CustomerModal, [{
    key: "onSubmitOk",
    value: function onSubmitOk() {
      return "";
    }
  }, {
    key: "fetchBuildings",
    value: function () {
      var _fetchBuildings = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _yield$buildingApi$fi, buildings;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _building.buildingApi.findAll();
              case 2:
                _yield$buildingApi$fi = _context.sent;
                buildings = _yield$buildingApi$fi.data.buildings;
                this.buildings = buildings;
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function fetchBuildings() {
        return _fetchBuildings.apply(this, arguments);
      }
      return fetchBuildings;
    }()
  }, {
    key: "handleBlock",
    value: function () {
      var _handleBlock = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.form.isBlock) {
                  _context2.next = 10;
                  break;
                }
                _context2.next = 3;
                return this.$confirm("Xác nhận mở khóa khách hàng này?", "Cảnh báo", {
                  cancelButtonText: "Không",
                  confirmButtonText: "Mở khóa",
                  type: "warning"
                });
              case 3:
                _context2.next = 5;
                return _customer.customerApi.unBlock(this.form.id);
              case 5:
                this.visible = false;
                this.onSubmitOk();
                this.$notify({
                  title: "Thông báo",
                  message: "Mở khóa thành công",
                  type: "success"
                });
                _context2.next = 12;
                break;
              case 10:
                _context2.next = 12;
                return this.$confirm("Xác nhận mở khóa hàng này?", "Cảnh báo", {
                  cancelButtonText: "Không",
                  confirmButtonText: "Khóa",
                  type: "warning"
                });
              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function handleBlock() {
        return _handleBlock.apply(this, arguments);
      }
      return handleBlock;
    }()
  }, {
    key: "dataSubmit",
    get: function get() {
      return {
        customer: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), {}, {
          name: this.form.name,
          address: this.form.address
        }),
        buildingId: this.form.buildingId
      };
    }
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.$refs.form.validate();
              case 2:
                this.loading = true;
                _context3.prev = 3;
                _context3.next = 6;
                return _customer.customerApi.create(this.dataSubmit);
              case 6:
                this.$notify({
                  title: "Thông báo",
                  message: "Tạo mới thành công",
                  type: "success"
                });
                this.visible = false;
                this.onSubmitOk();
              case 9:
                _context3.prev = 9;
                this.loading = false;
                return _context3.finish(9);
              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3,, 9, 12]]);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.$refs.form.validate();
              case 2:
                this.loading = true;
                _context4.prev = 3;
                _context4.next = 6;
                return _customer.customerApi.update(this.form.id, this.dataSubmit);
              case 6:
                this.$notify({
                  title: "Thông báo",
                  message: "Cập nhật thành công",
                  type: "success"
                });
                this.visible = false;
                this.onSubmitOk();
              case 9:
                _context4.prev = 9;
                this.loading = false;
                return _context4.finish(9);
              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3,, 9, 12]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.visible = true;
      this.status = "create";
      this.form = {};
      this.tab = "info";
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      var _data$building;
      this.tab = "info";
      this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        buildingId: (_data$building = data.building) === null || _data$building === void 0 ? void 0 : _data$building.id
      });
      this.visible = true;
      this.status = "update";
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchBuildings();
    }
  }]);
  return CustomerModal;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Emit)("submit:ok")], CustomerModal.prototype, "onSubmitOk", null);
CustomerModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    SingleImage: _SingleImage.default
  }
})], CustomerModal);
var _default = CustomerModal;
exports.default = _default;